export interface RTSDebtorResponse {
    _id: string
    name: string
    mc_number: string
    rating: string
    averageDaysToPayPast60: string
    city: string
    state: string
    lastActivity?: string
    lastCreditScoreChange?: string
    phone?: string
    email?: string
    dot_number?: string
    address1?: string
    address2?: string
    collectionQueue?: string
    previousRating?: string
}

/**
 * Formats MC number to ensure proper matching with RTS system
 * If MC number is 5 digits, add a leading zero
 * @param mcNumber The MC number to format
 * @returns Formatted MC number
 */
export const formatMCNumber = (mcNumber: string): string => {
    const digitsOnly = mcNumber.toString().replace(/\D/g, '')
    return digitsOnly.padStart(6, '0')
}
